// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import VueRouter from 'vue-router'
import App from './App'
// import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import QS from 'qs';
// import AMap from 'vue-amap'
import api from './http/http'
import Cookie from './http/cookie'
import Promise from 'bluebird'
import store from './store/index'
import VueLazyload from 'vue-lazyload'

Vue.prototype.$hostname = () => {
  if (process.env.NODE_ENV == 'development') {
    // return 'zscfx.yilvbao.cn'
    return 'fenxiao.yeahtour.cn'
  } else {
    return window.location.hostname
  }
}

Vue.use(VueLazyload, {
  // loading: '../webchat/static/lazy.svg'
  loading: require('./assets/loading.png')
})

// Vue.use(AMap)
Vue.use(VueRouter)
Vue.use(VueAwesomeSwiper)
Vue.use(Cookie)
// AMap.initAMapApiLoader({
//   key: '43dc89a281dc12fcdbbe4230a54f25b9',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
// })
// axios.defaults.baseURL = __BASE__;
window.Promise = Promise;

import '../src/assets/styles/border.css';
import '../src/assets/styles/reset.css';
import './assets/js/common.js';
import 'vue-carbon/dist/vue-carbon.css'
// import 'element-ui/lib/theme-chalk/index.css';
// import ElementUI from 'element-ui';
import './utils/formatDate'

// Vue.prototype.$http = axios
Vue.prototype.$userId = ''
// Vue.prototype.QS = QS
// Vue.prototype.$api = api
Vue.prototype.$Cookie = Cookie
FastClick.attach(document.body)
// Vue.use(ElementUI);
Number.prototype.mul = function (arg) {
  return accMul(arg, this);
}
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app-box')



function accMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();

  try {
    m += s1.split(".")[1].length
  } catch (e) {}
  try {
    m += s2.split(".")[1].length
  } catch (e) {}
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}



// WEBPACK FOOTER //
// ./src/main.js